import React from "react";

import { cn } from "@/utils/helpers/classnames";

interface ParagraphProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  className?: string;
}

const Paragraph: React.FC<ParagraphProps> = ({ children, className = "", ...props }) => {
  const sizeClasses = "text-sm xl:text-base";
  const hasHtmlContent = Boolean(props.dangerouslySetInnerHTML);
  const Tag = hasHtmlContent ? "div" : "p";

  return (
    <Tag {...props} className={cn(`font-inter ${sizeClasses} text-text-primary ${className}`)}>
      {!hasHtmlContent ? children : null}
    </Tag>
  );
};

export default Paragraph;
